module.exports = __webpack_public_path__ + "static/media/germanSuperHeavyArtillery.7ce8b69d.jpg";